// Check if current page is homepage / root page
function isHomepage() {
    let windowPathname = window.location.pathname;
    if (windowPathname === '/') {
        return true;
    } else {
        return false;
    }
}

// Create Element.remove() function if not exist
if (!('remove' in Element.prototype)) {
    Element.prototype.remove = function () {
        if (this.parentNode) {
            this.parentNode.removeChild(this);
        }
    };
}

// Collapse header on scroll only when tagline exists
let headerTagline = document.querySelector('.header-tagline');
if (isHomepage() === false) {
    headerTagline.remove();
}
if (isHomepage() === true && headerTagline) {
    var cur = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;

    // Scroll functionality
    window.addEventListener('scroll', function () {
        var scrolledTo = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
        if (cur > scrolledTo) {
            headerTagline.classList.remove('hide');
        }
        if (cur < scrolledTo) {
            headerTagline.classList.add('hide');
        }
        cur = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
    });
}


// Meganav - add class when meganav is open so link maintains style. On mouseout, remove class
let meganav = document.querySelectorAll('.meganav');

[].forEach.call(meganav, function (nav) {
    let meganavContainer = nav.parentElement;
    let navLink = meganavContainer.querySelector('.nav-item-link');
    nav.addEventListener('mouseenter', function () {
        navLink.classList.add('meganavIsOpen');
        meganavContainer.addEventListener('mouseleave', function () {
            navLink.classList.remove('meganavIsOpen');
        });
    });
});


// Dynamic distance - based on height of header, set padding-top of <main> tag. This changes at various heights, but b/c
// the headers are fixed, this is necessary
function updateMainSpacing() {
    var header;
    var mobileAlert;
    let main = document.querySelector('header + main');
    var alertInHeader = document.querySelector('.header .alert');
    var alertInAlertMobile = document.querySelector('.alert-mobile .alert');
    var headerDesktop = document.querySelector('.header-desktop');
    var siteAlertMessage = document.querySelector('.alert .alert-text>p');

    if (siteAlertMessage !== null) {
        alertInHeader.style.display = 'inline-table';
        alertInAlertMobile.style.display = 'inline-table';
    }

    if (alertInHeader != null && (alertInHeader.style.display != 'none')) { //shift spacing
        headerDesktop.style.paddingBottom = '0px';
        alertInHeader.style.marginTop = '30px';
    }

    if (window.innerWidth > 1000) { // $navChangesAt
        header = headerDesktop;
    } else {
        header = document.querySelector('.header-mobile');
        mobileAlert = document.querySelector('.alert-mobile');
    }

    if (header && main) {
        let mobileSearchIsOpen = document.querySelector('.mobileSearchIsOpen');
        if (mobileSearchIsOpen) {
            mobileSearchIsOpen.classList.remove('mobileSearchIsOpen');
            mobileSearchInput.blur();
            focusState = false;
        }

        var fullHeight;
        if (siteAlertMessage != null && (mobileAlert != null)) { //if siteAlert exist and on mobile
            fullHeight = header.clientHeight + mobileAlert.clientHeight;
        } else {
            fullHeight = header.clientHeight;
        }
        let headerHeight = `${fullHeight}px`;

        main.style.paddingTop = headerHeight;
    }
}

//negate int
window.addEventListener('load', updateMainSpacing);
function toggleHeight(height) {
    return -height;
}


//shift header on mobile hamburger
let headerMobileHamburger = document.querySelector('.header-mobile-hamburger');

if (headerMobileHamburger) {
    headerMobileHamburger.addEventListener('click', function () {
        document.body.classList.toggle('mobileNavIsOpen');

        var siteAlert;
        let mobileNav = document.querySelector('.mobileNavIsOpen .mobile-nav');

        if (window.innerWidth > 1000) { // $navChangesAt
            siteAlert = document.querySelector('.alert');
        } else {
            siteAlert = document.querySelector('.alert-mobile');
        }
        // Mobile hamburger menu toggle

        var newHeight = toggleHeight(siteAlert.clientHeight);
        var newHeightpx = `${newHeight}px`;
        mobileNav.style.top = newHeightpx;
    });
}

// Mobile subnav - toggle open / close
let mobileNavPrimary = document.querySelectorAll('.mobile-nav-item');

[].forEach.call(mobileNavPrimary, function (primaryNavItem) {
    let correspondingSubnav = primaryNavItem.nextElementSibling;
    primaryNavItem.addEventListener('click', function () {
        primaryNavItem.classList.toggle('active');
        correspondingSubnav.classList.toggle('mobileSubnavIsOpen');
    });
});


// Resize event handler and function calls
var width = window.innerWidth;
window.addEventListener('resize', function () {
    if (window.innerWidth !== width) {
        window.requestAnimationFrame(updateMainSpacing);
    }
    width = window.innerWidth;
});